export default __webpack_public_path__ + "static/media/rapidresponse.cfab9c5f.png";